import React, { useState } from 'react';
import Reseau from './Reseau';
import Partner from './Partner';
import { PARTNERS_GRID_PARTNERS } from '../utils';
var Display = function () {
    var _a = useState(0), activeId = _a[0], setActiveId = _a[1];
    var partners = JSON.parse(PARTNERS_GRID_PARTNERS);
    return (React.createElement("div", { className: 'partner-container container' }, partners.map(function (element) {
        return (element.type && element.type == "reseau"
            ? React.createElement(Reseau, { element: element, activeId: activeId, setActiveId: setActiveId })
            : React.createElement(Partner, { element: element, activeId: activeId, setActiveId: setActiveId }));
    })));
};
export default Display;
